import React, { useEffect, useState } from "react";
import { Button, Flex, Typography } from "antd";

import TreatmentCardStep2 from "./TreatmentCardStep2";
import DashboardPage from "./Payments/DashboardPage";
// import Payments from "./Payments/Payments";

import phone from "../../../assets/icons/call.svg";
import email from "../../../assets/icons/sms3.svg";
import ScrapeJobsBanner from "../../ScrapeJobs/ScrapeJobsBanner";

export default function TreatmentPlanDetailsOrPaymentRequest({
  setSelectedPatient,
  setCurrentStep,
  newPatientID,
  currentStep,
  selectedPatient,
  selectedSegment,
}) {
  const [treatmentOrPaymentSwitch, setTreatmentOrPaymentSwitch] = useState(
    localStorage.getItem("treatment.pat_id") || selectedSegment === "ar-cases" || selectedSegment === "ar-handled" ? "payment" : "treatment",
  );

  useEffect(function () {
    if (localStorage.getItem("treatment.pat_id")) {
      localStorage.removeItem("treatment.pat_id");
    }
  }, []);

  return (
    <div>
      <ScrapeJobsBanner
        patientId={selectedPatient && selectedPatient.id}
        patientTags={(selectedPatient && selectedPatient.tags) || []}
        manualAttentionNote={selectedPatient && selectedPatient.manual_attention_note}
        manualAttentionNoteSetAt={selectedPatient && selectedPatient.manual_attention_note_set_at}
      />
      <div style={{ display: "flex", flexDirection: "row" }}>
        <Flex vertical gap={5}>
          <Typography.Title level={5} style={{ marginBottom: 0, marginTop: 0 }}>
            {selectedPatient.first_name} {selectedPatient.last_name}'s Treatment Plan
          </Typography.Title>

          <Flex align="center" gap={5}>
            <img src={email} alt="email" style={{ marginRight: "8px", width: 18, height: 18 }} />
            <Typography.Paragraph style={{ marginBottom: 0, marginTop: 0 }}>{selectedPatient.email || "-"}</Typography.Paragraph>
          </Flex>

          <Flex align="center" gap={5}>
            <img src={phone} alt="phone-number" style={{ marginRight: "8px", width: 18, height: 18 }} />
            <Typography.Paragraph style={{ marginBottom: 0, marginTop: 0 }}>{selectedPatient.phone || "-"}</Typography.Paragraph>
          </Flex>
        </Flex>

        <Button
          style={{
            border: "1px solid #6B43B5",
            color: "#6B43B5",
            marginLeft: "auto",
            width: 154,
            height: 34,
          }}
          onClick={() => setCurrentStep(1)}
        >
          Back
        </Button>
      </div>

      {/* Switch */}
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: 30,
          marginBottom: 30,
        }}
      >
        <div
          style={{
            borderRadius: 100,
            boxShadow: "0 0 10px 0 rgba(0,0,0,0.15)",
            padding: "7px",
            display: "inline-flex",
            alignItems: "center",
            gap: 10,
            width: "100%",
          }}
        >
          <Button
            className={`treatment-financing-insurance-tabs ${treatmentOrPaymentSwitch === "treatment" ? "active" : ""} `}
            onClick={() => setTreatmentOrPaymentSwitch("treatment")}
            // style={{ cursor: isGettingBoardStatisticsData ? "not-allowed" : "pointer" }}
            // disabled={isGettingBoardStatisticsData}
          >
            Treatment Plans
          </Button>
          <Button
            className={`treatment-financing-insurance-tabs ${treatmentOrPaymentSwitch === "payment" ? "active" : ""} `}
            onClick={() => setTreatmentOrPaymentSwitch("payment")}
            // style={{ cursor: isGettingBoardStatisticsData ? "not-allowed" : "pointer" }}
            // disabled={isGettingBoardStatisticsData}
          >
            Account Receivable
          </Button>
        </div>
      </div>

      {treatmentOrPaymentSwitch === "treatment" ? (
        <TreatmentCardStep2
          setSelectedPatient={setSelectedPatient}
          setCurrentStep={setCurrentStep}
          newPatientID={newPatientID}
          currentStep={currentStep}
          data={selectedPatient} // Pass the selected patient data
        />
      ) : (
        // The Payment Page
        <DashboardPage setCurrentStep={setCurrentStep} selectedPatient={selectedPatient} />
      )}
    </div>
  );
}
